export enum HEADER_TYPE {
    GENERATE_OTP = 'generateOtp',
    JOIN_COMMUNITY = 'joinCommunity',
    VERIFY_OTP = 'verifyOtp',
    LOGIN = 'login',
    QUESTION = 'question',
    COMMUNITY_DETAIL = 'communityDetail',
    MEMBER_DIRECTORY = 'memberDirectory',
    CHATROOM = 'chatroom'
}